import { render } from "./EditGoalForGroup.vue?vue&type=template&id=2a4a24c6&scoped=true"
import script from "./EditGoalForGroup.vue?vue&type=script&lang=js"
export * from "./EditGoalForGroup.vue?vue&type=script&lang=js"

import "./EditGoalForGroup.vue?vue&type=style&index=0&id=2a4a24c6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4a24c6"]])

export default __exports__